import { Camera, FileText, ShieldCheck, CalendarCheck } from "lucide-react";

const DOCS = [
    {
        id: "relatorio",
        icon: Camera,
        title: "Relatório Fotográfico",
        text: "Registo fotográfico completo antes e depois de cada intervenção. Prova visual do estado inicial e do resultado final, para total transparência.",
        items: [
            "Fotografias antes/depois de cada equipamento",
            "Registo de hottes, condutas, motores e turbinas",
            "Entregue no final de cada limpeza",
        ],
    },
    {
        id: "ficha-tecnica",
        icon: FileText,
        title: "Ficha Técnica",
        text: "Documento técnico com o detalhe da intervenção realizada: equipamentos intervencionados, produtos utilizados e recomendações de manutenção.",
        items: [
            "Descrição dos trabalhos executados",
            "Produtos e métodos utilizados",
            "Data e periodicidade recomendada",
        ],
    },
];

const HIGHLIGHTS = [
    {
        id: "haccp",
        icon: ShieldCheck,
        content: (
            <>
                Documentação de suporte às normas{" "}
                <span className="text-white font-semibold">HACCP</span> e
                segurança contra incêndio
            </>
        ),
    },
    {
        id: "historico",
        icon: CalendarCheck,
        content: (
            <>
                Histórico de intervenções que comprova a{" "}
                <span className="text-white font-semibold">manutenção periódica</span>{" "}
                do seu sistema
            </>
        ),
    },
];

const DocCard = ({ doc }) => (
    <article
        data-testid={`certification-card-${doc.id}`}
        className="group bg-[#0F1210] p-8 md:p-12 hover:bg-[#141915] transition-colors reveal"
    >
        <div className="w-14 h-14 flex items-center justify-center border border-[#2E7D5B]/50 mb-8 group-hover:bg-[#2E7D5B]/15 transition-colors">
            <doc.icon className="w-7 h-7 text-[#7BC9A4]" />
        </div>
        <h3 className="font-display text-2xl md:text-3xl font-bold uppercase tracking-tight mb-4 leading-tight">
            {doc.title}
        </h3>
        <p className="text-white/55 text-sm leading-relaxed mb-8 font-light">
            {doc.text}
        </p>
        <ul className="space-y-3">
            {doc.items.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-white/75">
                    <span className="w-1.5 h-1.5 bg-[#9B2C2C] mt-1.5 flex-shrink-0" />
                    <span>{item}</span>
                </li>
            ))}
        </ul>
    </article>
);

const SectionHeader = () => (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
        <div className="lg:col-span-5 reveal">
            <div className="flex items-center gap-3 mb-6">
                <span className="block w-12 h-px bg-[#2E7D5B]" />
                <span className="label-tag" style={{ color: "#7BC9A4" }}>
                    Documentação
                </span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-black uppercase tracking-tighter leading-[0.95]">
                Cada limpeza <br /> documentada.
            </h2>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 flex items-end reveal">
            <p className="text-base md:text-lg text-white/60 leading-relaxed font-light">
                No final de cada intervenção entregamos um relatório
                fotográfico e uma ficha técnica. Documentação essencial
                para auditorias HACCP, seguradoras e inspeções.
            </p>
        </div>
    </div>
);

const Certifications = () => (
    <section
        id="certificados"
        data-testid="certifications-section"
        className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#0F1210] text-white overflow-hidden"
    >
        <div className="max-w-7xl mx-auto relative z-10">
            <SectionHeader />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
                {DOCS.map((d) => (
                    <DocCard key={d.id} doc={d} />
                ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/10 border-t-0">
                {HIGHLIGHTS.map((h) => (
                    <div
                        key={h.id}
                        data-testid={`certification-highlight-${h.id}`}
                        className="flex items-center gap-4 bg-[#0F1210] p-6 md:p-8 reveal"
                    >
                        <h.icon className="w-6 h-6 text-[#7BC9A4] flex-shrink-0" />
                        <p className="text-sm text-white/70">{h.content}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default Certifications;
